module.exports = __webpack_public_path__ + "static/media/toss_white_icon.2fae32fe.png";